import React from "react";
import "./Home.css";

const Home = () => {

  return (
    <div className="home-container">
      <h1 className="home-title">Secret Santa</h1>
      <p className="home-subtitle">
        Welcome to the game! Click below to start a gift exchange.
      </p>
      <button className="home-button" onClick={() =>  window.location.href = "https://www.youtube.com/watch?v=WHCZI47A-H8"}>
        Start Game
      </button>
    </div>
  );
};

export default Home;
